import { connect } from 'react-redux';
import { Product } from './product';
import productPageSelector from './connect/product-page.selector';
import productPageDispatcher from './connect/product-page.dispatcher';
export default connect(productPageSelector, productPageDispatcher)(Product);